import { isEmpty } from 'lodash';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { Redirect, Route } from 'react-router-dom';
import { userTypes, NonAuthRoutes, ExternalUserRoutes, AdminRoutes } from '../app/enums';
import { useUserContext } from '../context/UserContext';

export interface IAuthRouteProps {
  Component: React.FC<RouteComponentProps>;
  path: string;
  exact?: boolean;
}

export default function AuthRoute({
  Component,
  path,
  exact = false,
}: IAuthRouteProps) {
  const { state, dispatch } = useUserContext();
  const isAuthed = !isEmpty(state.accessToken) && state.self.authenticated;
  const isAllowed = (state.self.userType === userTypes.EXTERNAL 
    && Object.values(ExternalUserRoutes).includes(path as ExternalUserRoutes))
    || (state.self.userType === userTypes.INTERNAL
      && Object.values(AdminRoutes).includes(path as AdminRoutes))

  if(state.currentPage !== path && isAllowed){
    dispatch({
      type: 'field',
      fieldName: 'currentPage',
      payload: path,
    })
  } 

  return (
    <Route
      exact={exact}
      path={path}
      render={(props: RouteComponentProps) =>
        isAuthed && isAllowed ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: NonAuthRoutes.login,
              state: {
                requestedPath: path,
              },
            }}
          />
        )
      }
    />
  );
}
